import createTheme from '@/themes/createTheme.ts'

// const rowSelectedBg = '#F0F6FF'
// const rowSelectedHoverBg = '#E3EEFF' // 主题 衍生色  按钮背景  hover等效果

const theme = {
  mainColor: '#0053CF', // 主题色 #13655B 绿色
  visionColor: '#f0f5ff', // 主题 衍生色  按钮背景  hover等效果
  rowSelectedBg: '#F0F6FF',
  rowSelectedHoverBg: '#E3EEFF', // 主题 衍生色  按钮背景  hover等效果
  headerIconBorder: '#adc6ff', //  导航图标边框
  headerIconBg: '#597ef7', //  导航图标背景
}

export default createTheme(theme)
